import useFadeIn from '../../hooks/useFadeIn';
import './Projects.css';

const projects = [
  {
    title: '3 Dogs Advisory',
    subtitle: 'Fractional CTO Consulting',
    description:
      'Technology advisory for growth-stage companies. Engineering org design, agile transformation, and AI strategy — helping teams build the leadership and processes to scale.',
    url: 'https://3dogsadvisory.com',
    icon: (
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
        <rect width="40" height="40" rx="10" fill="rgba(196,115,59,0.15)" />
        <path d="M12 28V16l8-6 8 6v12H12z" stroke="#C4733B" strokeWidth="2" strokeLinejoin="round" fill="none" />
        <rect x="17" y="22" width="6" height="6" rx="1" stroke="#C4733B" strokeWidth="1.5" fill="none" />
      </svg>
    ),
  },
  {
    title: 'Griddle',
    subtitle: 'Daily Word Puzzle Game',
    description:
      'A daily word challenge that tests vocabulary and pattern recognition. Built for puzzle enthusiasts who love a new brain teaser every day.',
    url: 'https://thegriddlegame.com',
    icon: (
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
        <rect width="40" height="40" rx="10" fill="rgba(196,115,59,0.15)" />
        <rect x="10" y="10" width="8" height="8" rx="2" stroke="#C4733B" strokeWidth="1.5" fill="none" />
        <rect x="22" y="10" width="8" height="8" rx="2" stroke="#C4733B" strokeWidth="1.5" fill="none" />
        <rect x="10" y="22" width="8" height="8" rx="2" stroke="#C4733B" strokeWidth="1.5" fill="none" />
        <rect x="22" y="22" width="8" height="8" rx="2" stroke="#C4733B" strokeWidth="1.5" fill="none" />
      </svg>
    ),
  },
  {
    title: 'StrictlyFlow',
    subtitle: 'Project Management Platform',
    description:
      'Kanban boards built for flow. WIP limits, cycle-time analytics, board chaining, and real-time collaboration — shipping work without the busywork.',
    url: 'https://dev.strictlyflow.com',
    icon: (
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
        <rect width="40" height="40" rx="10" fill="rgba(196,115,59,0.15)" />
        <rect x="10" y="12" width="6" height="16" rx="2" stroke="#C4733B" strokeWidth="1.5" fill="none" />
        <rect x="17" y="16" width="6" height="12" rx="2" stroke="#C4733B" strokeWidth="1.5" fill="none" />
        <rect x="24" y="10" width="6" height="18" rx="2" stroke="#C4733B" strokeWidth="1.5" fill="none" />
      </svg>
    ),
  },
];

const ArrowIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
    <path d="M4.5 3.5L11 8l-6.5 4.5V3.5z" />
  </svg>
);

const Projects = () => {
  const [ref, isVisible] = useFadeIn();

  return (
    <section className="projects section" id="projects">
      <div className={`container fade-in ${isVisible ? 'visible' : ''}`} ref={ref}>
        <p className="section-eyebrow">Projects</p>
        <h2 className="section-heading projects__heading">What I'm Building</h2>
        <div className="projects__grid">
          {projects.map((project, i) => (
            <a
              key={i}
              href={project.url}
              target="_blank"
              rel="noopener noreferrer"
              className="project-card"
            >
              <div className="project-card__icon">{project.icon}</div>
              <h3 className="project-card__title">{project.title}</h3>
              <p className="project-card__subtitle">{project.subtitle}</p>
              <p className="project-card__desc">{project.description}</p>
              <span className="project-card__link">
                Visit <ArrowIcon />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
